module.exports = __webpack_public_path__ + "static/hero-illustration2-81d9ae52ceac949e51aad3f7682678fc.png";